'use client';

import type { PostType } from '@prisma/client';
import NavigationButtons from './navigation-buttons';

interface HeroSectionProps {
  postType?: PostType;
}

export default function HeroSection({ postType }: HeroSectionProps) {
  // Default title and description for general posts
  let title = 'Travel Posts';
  let description =
    'Discover our latest travel stories, guides, and inspirations for your next adventure';

  // Set specific content based on the path
  if (postType === 'Article') {
    title = 'Travel Articles';
    description =
      'Discover our latest travel guides, tips, and inspirations for your next adventure';
  } else if (postType === 'News') {
    title = 'Travel News';
    description =
      'Stay updated with the latest travel news, updates, and announcements';
  } else {
    title = 'Explore Our Travel Blog';
    description =
      'Dive into stories from the road, traveler experiences, and updates from our journeys across Iraq, Oman, Jordan, and beyond.';
  }

  return (
    <section
      data-aos="fade-up"
      className="w-full flex flex-col text-center items-center pt-16 px-4"
    >
      <h2 className="xl:text-8xl font-[500] pb-6">{title}</h2>
      <p className="text-xl text-gray-500 font-[300] max-w-4xl mb-8">{description}</p>
      <NavigationButtons />
    </section>
  );
}
